export const FETCH_SHIPPERS_REQUEST = "FETCH_SHIPPERS_REQUEST";
export const FETCH_SHIPPERS_SUCCESS = "FETCH_SHIPPERS_SUCCESS";
export const FETCH_SHIPPERS_FAIL = "FETCH_SHIPPERS_FAIL";
export const EXPORT_SHIPPERS_REQUEST = "EXPORT_SHIPPERS_REQUEST";
export const EXPORT_SHIPPERS_SUCCESS = "EXPORT_SHIPPERS_SUCCESS";
export const EXPORT_SHIPPERS_FAIL = "EXPORT_SHIPPERS_FAIL";
